import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ErrorHandler from 'common/error/components/error-handler';
import { useLocation, useParams } from 'react-router';
import useDeepCompareEffect from 'use-deep-compare-effect';
import SearchResultsComponent from '../../components/overview/search-overview-results';
import { search as searchAction, clearSearch as clearSearchAction } from '../search-actions';
import performSearch from '../../helper';

const SearchResults = ({
  clearSearch,
  search,
  results,
  isLoading,
  error,
  shouldRefetch,
  searchFilters,
}) => {
  const params = useParams();
  const location = useLocation();
  const doSearch = () => {
    performSearch(params, search, searchFilters, location);
  };

  useEffect(() => () => {
    clearSearch();
  }, []);

  useEffect(() => {
    if (shouldRefetch) {
      doSearch();
    }
  }, [shouldRefetch]);

  useDeepCompareEffect(() => {
    const qParams = location.state;
    if (qParams?.searchFilters && Object.keys(searchFilters).length && Object.keys(params)) {
      doSearch();
    }
  }, [searchFilters]);

  useDeepCompareEffect(() => {
    const qParams = location.state;
    if (
      ((!qParams?.searchFilters && !Object.keys(searchFilters).length) ||
        Object.keys(searchFilters).length) &&
      Object.keys(params)) {
      doSearch();
    }
  }, [params]);

  return (
    <>
      <ErrorHandler type='notification' error={error} />
      <SearchResultsComponent results={results} isLoading={isLoading} />
    </>
  );
};

SearchResults.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  results: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  shouldRefetch: PropTypes.bool,
  searchFilters: PropTypes.object,
};

const mapStateToProps = state => ({
  searchValue: state.search.searchValue,
  results: state.search.overview.results,
  isLoading: state.search.overview.isLoading, // required by withLoading
  error: state.search.overview.error,
  shouldRefetch: state.search.type.shouldRefetch,
  searchFilters: state.search.searchFilters,
});

const mapDispatchToProps = { search: searchAction, clearSearch: clearSearchAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchResults);
